export function getTheme(c, force, fallback) {
    // get active skin
    const nameDiv = document.createElement("DIV");
    nameDiv.className = "wx-theme";
    c.appendChild(nameDiv);
    let theme = window
        .getComputedStyle(nameDiv)
        .getPropertyValue("--wx-theme-name");
    c.removeChild(nameDiv);
    if ((force && force !== theme) || (!force && !theme && fallback)) {
        if (theme)
            c.classList.remove(`wx-${theme}-theme`);
        theme = force || fallback;
        c.classList.add(`wx-${theme}-theme`);
    }
    return theme;
}
//# sourceMappingURL=context.js.map